import { Schema } from "effect";

// Outlook-specific provider data
export const OutlookProviderData = Schema.Struct({
  provider: Schema.Literal("outlook"),
  outlookMessageId: Schema.String,
  outlookConversationId: Schema.NullOr(Schema.String),
});
export type OutlookProviderData = typeof OutlookProviderData.Type;
